/* eslint-disable no-shadow */
/* eslint-disable import/no-cycle */
/* eslint-disable react/no-unstable-nested-components */
import React, { useCallback, useContext, useMemo, useState } from 'react';
import { v4 as uuid } from 'uuid';
import Modal from '../../components/Modal/Modal';

const ModalContext = React.createContext();

export const useModalContext = () => useContext(ModalContext);

export function ModalProvider({ children }) {
  const [controls, setControls] = useState({});

  const isOpen = useCallback(key => controls[key], [controls]);

  const getControl = useCallback(
    key => ({
      open: () => setControls(values => ({ ...values, [key]: true })),
      close: () => setControls(values => ({ ...values, [key]: false })),
    }),
    []
  );

  const createModal = useCallback(
    showCloseButton => {
      const key = uuid();

      return {
        element: ({ children }) => (
          <Modal id={key} showCloseButton={showCloseButton}>
            {children}
          </Modal>
        ),
        ...getControl(key),
      };
    },
    [getControl]
  );

  const value = useMemo(
    () => ({
      createModal,
      getControl,
      isOpen,
    }),
    [createModal, getControl, isOpen]
  );

  return <ModalContext.Provider value={value}>{children}</ModalContext.Provider>;
}
